export type RandomPasswordSettings = {
  length: number;
  numbers?: boolean;
  symbols?: boolean;
  uppercase?: boolean;
  lowercase?: boolean;
};

/**
 * Genera una contraseña aleatoria cumpliendo con los requisitos de complejidad.
 * Siempre incluirá al menos una mayúscula, un número y un símbolo si están habilitados.
 */
export function randomPassword({
  length = 12,
  numbers = true,
  symbols = true,
  uppercase = true,
  lowercase = true
}: RandomPasswordSettings): string {
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const nums = '0123456789';
  const syms = '@$!%*?&';

  let chars = '';
  if (lowercase) chars += lower;
  if (uppercase) chars += upper;
  if (numbers) chars += nums;
  if (symbols) chars += syms;

  if (chars.length === 0) return '';

  const passwordChars: string[] = [];

  // ✅ Garantiza al menos uno de cada tipo habilitado
  if (lowercase) passwordChars.push(lower[Math.floor(Math.random() * lower.length)]);
  if (uppercase) passwordChars.push(upper[Math.floor(Math.random() * upper.length)]);
  if (numbers) passwordChars.push(nums[Math.floor(Math.random() * nums.length)]);
  if (symbols) passwordChars.push(syms[Math.floor(Math.random() * syms.length)]);

  // ✅ Completa el resto de la contraseña con caracteres aleatorios
  while (passwordChars.length < length) {
    const randomChar = chars[Math.floor(Math.random() * chars.length)];
    passwordChars.push(randomChar);
  }

  // ✅ Mezcla el resultado para evitar patrones predecibles
  for (let i = passwordChars.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [passwordChars[i], passwordChars[j]] = [passwordChars[j], passwordChars[i]];
  }

  return passwordChars.join('');
}